const getStringFromRouterQuery = (
  urlQuery: string | string[] | undefined | null,
): string => {
  if (!urlQuery) return '';
  if (typeof urlQuery === 'string') return urlQuery;
  if (urlQuery[0]) return urlQuery[0];
  return '';
};

export { getStringFromRouterQuery };
